import React from 'react';
import { connect } from 'react-redux';
import IntlContext from './IntlContext';

const IntlProvider = ({ intl, children }) => (
  <IntlContext.Provider value={intl}>
    {children}
  </IntlContext.Provider>
);

const mapStateToProps = ({ intl }) => ({
  intl
});

export default connect(mapStateToProps, null, null)(IntlProvider);
